import { Dispatch, ReactElement, SetStateAction } from "react";

import { CSSObject } from "@emotion/react";
import { useOnClickOff } from "@newsela/angelou";

import {
  absoluteContainerCss,
  getContainerPositionCss,
  subNavMenuPositionCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.styles";

const NavButtonWithPopout = ({
  id,
  isOpen,
  setIsOpen,
  position,
  isSubNavMenu,
  rootCustomCss = {},
  ButtonComponent,
  PopoutComponent,
}: INavMenuPopout) => {
  const closeMenu = (e: KeyboardEvent) => {
    const isEventFromSelf =
      (e.target as HTMLButtonElement).id === id ||
      (e.target as HTMLButtonElement).classList.contains(id);
    if (isEventFromSelf) return;
    setIsOpen(false);
  };
  const clickOffRef = useOnClickOff(closeMenu);

  const closeMenuOnEscape = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      event.stopPropagation();
      document.getElementById(id)?.focus();
      setIsOpen(false);
    }
  };

  const { top, right, bottom, left } = position;

  return (
    <li
      // @ts-expect-error typescript complains about generic KeyboardEvent
      onKeyDown={closeMenuOnEscape}
      css={[getContainerPositionCss(isSubNavMenu), rootCustomCss]}
    >
      {ButtonComponent}

      {isOpen && (
        <div
          ref={clickOffRef}
          data-testid="navmenupopout-container"
          aria-labelledby={id}
          css={[
            absoluteContainerCss,
            { top, right, bottom, left },
            isSubNavMenu && subNavMenuPositionCss,
          ]}
        >
          {PopoutComponent}
        </div>
      )}
    </li>
  );
};

export interface IAbsolutePosition {
  top?: number | string | undefined;
  right?: number | string | undefined;
  bottom?: number | string | undefined;
  left?: number | string | undefined;
}

interface INavMenuPopout {
  id: string;
  isOpen: boolean;
  isSubNavMenu?: boolean;
  hasSubNavMenu?: boolean;
  rootCustomCss?: CSSObject;
  position: IAbsolutePosition;
  ButtonComponent: ReactElement<HTMLButtonElement>;
  PopoutComponent: ReactElement;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

NavButtonWithPopout.displayName = "NavButtonWithPopout";
export { NavButtonWithPopout };
